/**
 * EntityTypeEntityDropdowns
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Types
import { AppState } from 'services/types';

// Components
import EntityDropdown from '../EntityDropdown';

// Selectors
// @ts-ignore
import { selectIds } from './selectors';

interface OwnProps {
    direction?: 'left' | 'right';
    selection?: boolean;
    fluid?: boolean;
    inline?: boolean;
    limit: number;
    offset: number;
}

interface ConnectedProps {
    ids: string[];
}

type Props = OwnProps & ConnectedProps;

export class EntityTypeEntityDropdowns extends React.PureComponent<Props> {
    render(): React.ReactNode {
        const { ids, direction, selection, fluid, inline } = this.props;

        return ids.map((id: string): React.ReactElement => (
            <EntityDropdown
                key={id}
                entityTypeId={id}
                direction={direction}
                selection={selection}
                fluid={fluid}
                inline={inline}
            />
        ));
    }
}

const mapStateToProps = createStructuredSelector<AppState, OwnProps, ConnectedProps>({
    ids: selectIds
});

export default connect(mapStateToProps)(EntityTypeEntityDropdowns);
